export default __webpack_public_path__ + "static/media/yowl.5a4abc0d.png";